<template>
  <span class="flex flex-col">
    <label class="text-white text-sm mb-1.5" :for="fieldId">{{ label }}</label>
    <input
      :id="fieldId"
      :name="name || label"
      :type="type"
      :inputmode="inputmode"
      :autocomplete="autocomplete"
      :required="required"
      :readonly="readonly"
      class="rounded-md bg-primary-500 px-3 py-3 text-white border border-primary-400 placeholder:text-subtle placeholder:opacity-60 focus:border-highlight focus:ring-1 focus:ring-highlight"
      :class="{ 'opacity-70 cursor-default': readonly }"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </span>
</template>

<script>
// Unique per instance so <label for> always points at its own input, even
// when two fields happen to share the same label text.
let uid = 0;

export default {
  name: "InputField",
  props: {
    placeholder: { default: "" },
    label: { default: "" },
    value: { default: "" },
    // Defaults to a text field; pass "password"/"email" to get the correct
    // masking, mobile keyboard and password-manager behaviour.
    type: { default: "text" },
    name: { default: "" },
    autocomplete: { default: "on" },
    inputmode: { default: undefined },
    required: { type: Boolean, default: false },
    // Shown for context only (e.g. which account a reset link belongs to).
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      fieldId: `input-field-${(uid += 1)}`,
    };
  },
};
</script>

<style scoped></style>
